import type { Shop } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/node'
import type { UseTranslationResponse } from 'react-i18next'

import type { CartFull } from '~/models/cart.server'
import type { ShopPromotion } from '~/schemas/shop'

export const getPromotionLabel = (
  promotion: ShopPromotion,
  t: UseTranslationResponse<string>['t']
) => {
  if (promotion.type === 'xPercentOff') {
    if (promotion.minSpend && promotion.minSpend > 0) {
      return t('components.manage_discounts.spend_x_to_get_x_off', {
        percentage: promotion.amount,
        amount: Number((promotion.minSpend / 100).toFixed(2)),
      })
    }

    return t('components.manage_discounts.x_off_store_wide', {
      percentage: promotion.amount,
    })
  }

  if (promotion.type === 'freeShipping') {
    if (promotion.minSpend && promotion.minSpend > 0) {
      return t('components.manage_discounts.spend_x_to_get_free_shipping', {
        amount: Number((promotion.minSpend / 100).toFixed(2)),
      })
    }

    return t('components.manage_discounts.free_shipping_store_wide')
  }

  return null
}

export const getActiveShopPromotions = (
  cart: SerializeFrom<CartFull>,
  shop: Shop
): Extract<ShopPromotion, { type: 'xPercentOff' }>[] => {
  const promotions = (shop.promotions as ShopPromotion[]) || []
  if (!cart || !promotions.length) return []

  const totalCartPrice = cart.cartLines.reduce((amount, item) => {
    return amount + item.quantity * item.productVariant.price
  }, 0)

  return promotions.filter(
    (
      promotion
    ): promotion is Extract<ShopPromotion, { type: 'xPercentOff' }> => {
      const minSpend = promotion.minSpend || 0

      return promotion.type === 'xPercentOff' && totalCartPrice >= minSpend
    }
  )
}
